import { render } from "./aFromRowLable.vue?vue&type=template&id=fb61e104"
import script from "./aFromRowLable.vue?vue&type=script&lang=js"
export * from "./aFromRowLable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__